export default "__VITE_ASSET__blvyHtSL__"